module.exports = __webpack_public_path__ + "img/100coin@2x.23f65c99.png";